import { Box } from "@mui/material";
import "./svg.css";

export default function Svg() {
  return (
    <div>
      <Box>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500 500"
        className="svg-logo"
      >
        <path
          className="Ring"
          fill="#fff"
          stroke="red"
          d="M385.537,164.289l62.113-77.642c2.603-3.471,2.603-6.942,0.868-10.414l-34.712-52.068
c-1.736-1.736-4.339-3.471-6.942-3.471H285.373c-2.603,0-5.207,1.736-7.81,3.471l-34.712,52.068
c-1.526,3.052-1.708,6.774,0.039,9.399c0.526,1.085,1.268,2.003,2.193,2.721l60.896,76.12
c-17.757,4.506-34.712,12.135-50.455,23.031c-27.526-18.637-58.806-27.961-91.642-27.961C72.763,159.542-1,233.305-1,324.424
s73.763,164.881,164.881,164.881c32.42,0,63.324-9.087,90.595-27.961c27.526,18.637,58.807,27.961,91.642,27.961
c91.119,0,164.881-73.763,164.881-164.881C511,246.895,457.594,181.942,385.537,164.289z M268.732,90.119h21.847l34.712,34.712
h-28.714L268.732,90.119z M314.878,72.763l31.241-31.241l31.241,31.241H314.878z M377.359,90.119l-31.241,31.241l-31.241-31.241
H377.359z M401.658,90.119h21.085l-27.464,34.712h-28.332L401.658,90.119z M425.194,72.763h-23.537l-34.712-34.712h35.58
L425.194,72.763z M289.712,38.051h35.58L290.58,72.763h-24.245L289.712,38.051z M324.424,159.542l-13.923-17.356h71.045
l-13.732,17.356H324.424z M16.356,324.424c0-81.573,65.953-147.525,147.525-147.525c31.241,0,60.746,9.546,85.912,28.637
c2.82,1.953,5.586,4.014,8.285,6.183c2.698,2.169,5.329,4.447,7.878,6.834c2.549,2.386,5.017,4.881,7.39,7.485
c1.186,1.302,2.349,2.631,3.486,3.986c1.137,1.356,2.249,2.739,3.334,4.149c20.827,26.034,31.241,57.275,31.241,90.251
c0,30.304-9.506,58.878-26.787,84.003c-3.708-2.629-7.272-5.481-10.625-8.591c-3.134-2.952-6.063-6.102-8.582-9.46
c13.017-19.959,19.959-42.522,19.959-65.953c0-26.034-7.81-50.332-23.43-71.159c-0.597-0.814-1.2-1.617-1.81-2.41
c-7.325-9.521-15.656-17.609-25.36-24.628c-2.426-1.755-4.938-3.443-7.541-5.07c-0.348-0.261-0.716-0.477-1.095-0.669
c-18.826-11.693-40.12-17.555-62.255-17.555c-66.82,0-121.492,54.671-121.492,121.492s54.671,121.492,121.492,121.492
c19.727,0,39.449-5.094,56.662-14.428c5.89,6.792,12.363,13.048,19.436,18.921c-23.361,13.786-49.298,21.541-76.098,21.541
C82.308,471.949,16.356,405.997,16.356,324.424z M299.974,231.113c14.384-7.208,30.262-10.824,46.145-10.824
c57.275,0,104.136,46.861,104.136,104.136c0,57.275-46.861,104.136-104.136,104.136c-15.883,0-31.761-3.617-46.145-10.824
c18.757-27.653,28.789-59.407,28.789-93.311C328.763,290.52,318.731,258.766,299.974,231.113z M241.983,324.424
c0-17.525,4.535-35.047,13.138-50.284c8.442,15.578,12.896,32.929,12.896,50.284c0,17.525-4.535,35.047-13.138,50.284
C246.438,359.13,241.983,341.779,241.983,324.424z M210.026,231.113c-18.757,27.653-28.789,59.407-28.789,93.311
c0,33.904,10.032,65.658,28.789,93.311c-14.384,7.208-30.262,10.824-46.145,10.824c-57.275,0-104.136-46.861-104.136-104.136
c0-57.275,46.861-104.136,104.136-104.136C179.764,220.288,195.642,223.905,210.026,231.113z M346.119,471.949
c-31.241,0-60.746-9.546-85.912-28.637c-9.871-6.834-19.078-14.997-27.039-24.488c-1.137-1.356-2.249-2.739-3.334-4.149
c-20.827-26.034-31.241-57.275-31.241-90.251c0-30.304,9.506-58.878,26.787-84.003c1.739,1.233,3.448,2.514,5.117,3.849
c4.943,4.243,9.516,8.976,14.089,14.202c-13.017,19.959-19.959,42.522-19.959,65.953c0,26.034,7.81,50.332,23.43,71.159
c9.546,13.017,20.827,23.43,34.712,32.108c0.348,0.261,0.716,0.477,1.095,0.669c18.826,11.693,40.12,17.555,62.255,17.555
c66.82,0,121.492-54.671,121.492-121.492s-54.671-121.492-121.492-121.492c-19.727,0-39.449,5.094-56.662,14.428
c-5.89-6.792-12.363-13.048-19.436-18.921c23.361-13.786,49.298-21.541,76.098-21.541c81.573,0,147.525,65.953,147.525,147.525
S427.692,471.949,346.119,471.949z"
        />
      </svg>
      </Box>
    </div>
  );
}
